import logo from '../imgs/logo.svg';
import './AppHeader.scss';
import TrialRemaining from './TrialRemaining';
import { Route, useHistory } from 'react-router';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import authProvider from '../helpers/authProvider';
import { resendLinkPath } from '../helpers/paths';
import { UserContextSummary } from '../models/dto/userContext';

export default function AppHeader() {
	const history = useHistory();
	const [userName, setUserName] = useState<string>(getUserName(authProvider.getUserContext()));

	useEffect(() => {
		// run again in case it changed since we first rendered.
		setUserName(getUserName(authProvider.getUserContext()));
		
		return authProvider.addUserContextChangedListener(userContext => {
			setUserName(getUserName(userContext));
		});
	}, []);
	
	return (
		<div className="app-header__outer-container">
			<div className="app-header__inner-container">
				<div className="flex-item-static">
					<Link to="/">
						<img src={logo} style={{height: 24 }} alt="Creovai logo" />
					</Link>
				</div>
				
				<div className="flex-item-static">
					<div className="app-header__divider"></div>
				</div>
				
				<div className="flex-item-growing-shrinking">
					<div className="app-header__baseline-item">
						Creovai Upload Portal
					</div>
				</div>
				
				<Route path="/engagements/:engagementId">
					<TrialRemaining />
				</Route>

				<div className="flex-item-static">
					<div className="app-header__full-divider"></div>
				</div>

				<div className="flex-item-static">
					<div className="text-small app-header__user-section-header">
						<span role="button" className="link" onClick={signOut}>Sign out</span>
					</div>
					<div className="text-bold ellipsis">{userName}</div>
				</div>
			</div>
		</div>
	)
	
	function signOut() {
		authProvider.signOut();
		history.push(resendLinkPath);
	}
	
	function getUserName(userContext: UserContextSummary | nundefined): string {
		if (userContext) {
			return `${userContext.firstName} ${userContext.lastName}`;
		} else {
			return '';
		}
	}
}